import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import GoogleButton from "@/components/GoogleButton";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Hoş geldin!");
      navigate(location.state?.from || "/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };


  const onGoogle = async (credential) => {
    try {
      const data = await googleLogin(credential);
      toast.success(data.new_user ? "Hoş geldin! 15 jeton hesabına yüklendi ✧" : "Hoş geldin!");
      navigate(location.state?.from || "/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Google girişi başarısız");
    }
  };

  return (
    <div className="cosmic-bg min-h-screen flex items-center justify-center px-4">
      <div className="stars" />
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-7 h-7 gold-text" />
          <span className="font-serif-myst text-3xl font-semibold">FalZilla</span>
        </Link>

        <div className="glass rounded-3xl p-8">
          <h1 className="font-serif-myst text-3xl mb-2 text-center">Tekrar hoş geldin</h1>
          <p className="text-white/60 text-center text-sm mb-6">Kalınan yerden devam et</p>

          <GoogleButton onCredential={onGoogle} text="signin_with" />
          <div className="text-center text-xs text-white/40 my-4">— veya —</div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs text-white/60 mb-1 block">E-posta</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]/50 transition-colors"
                placeholder="ornek@mail.com"
              />
            </div>
            <div>
              <label className="text-xs text-white/60 mb-1 block">Şifre</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]/50 transition-colors"
                placeholder="••••••••"
              />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit-btn" className="btn-gold w-full py-3 rounded-xl">
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>

          <div className="text-center text-sm text-white/60 mt-6 space-y-2">
            <div><Link to="/sifremi-unuttum" data-testid="login-forgot-link" className="text-white/50 hover:gold-text underline">Şifremi unuttum</Link></div>
            <div>Hesabın yok mu? <Link to="/kayit" data-testid="login-goto-register" className="gold-text hover:underline">Ücretsiz kayıt ol</Link></div>
          </div>
        </div>
      </div>
    </div>
  );
}
